export default {"src":"/_next/static/media/feature-3.e0428fbe.svg","height":198,"width":246,"blurWidth":0,"blurHeight":0};